<template>
  <a :href="`/apps/${app.application.id}?from=game_listing`">
    <game-icon
      :images="app.application.images"
      :ua="ua"
      :appName="app.application.name"
    />
    <div class="c-games_list_body">
      <h3 class="c-games_title">{{ app.application.name }}</h3>
      <p class="c-games_genre">{{ app.application.messageBundles.shortDescription }}</p>
      <div class="c-games_typeWrap">
        <div v-if="hasPCAppWin || hasPCAppMac" class="c-games_type c-games_type-pcApp">
          <ul v-if="hasPCAppWin || hasPCAppMac" class="c-label_os">
            <li v-if="hasPCAppWin" class="c-label_os_item">Win</li>
            <li v-if="hasPCAppMac" class="c-label_os_item">Mac</li>
          </ul>
          <div class="c-games_type_labelContainer">
            <span class="c-label c-label-gameType">PCアプリ</span>
          </div>
        </div>
        <div v-if="hasWeb" class="c-games_type">
          <div class="c-games_type_labelContainer">
            <span class="c-label c-label-gameType">PCブラウザ</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="ua === 'pc'" class="c-games_hoverBox">
      <p class="c-games_hoverBox_button c-games_hoverBox_button-detail">
        <DetailIcon class="svg"/>
      </p>
    </div>
  </a>
</template>

<script>
import DetailIcon from '@commonsvg/button_detail_icon.svg'
import GameIcon from '../atoms/GameIcon.vue'

export default {
  components: {
    DetailIcon,
    GameIcon
  },
  props: {
    app: Object,
    ua: String
  },
  computed: {
    hasPCAppWin () {
      if (!this.app.entryPoints) return false
      return this.app.entryPoints.find(e => e.id === 'win') !== undefined
    },
    hasPCAppMac () {
      if (!this.app.entryPoints) return false
      return this.app.entryPoints.find(e => e.id === 'mac') !== undefined
    },
    hasWeb () {
      if (!this.app.entryPoints) return false
      return this.app.entryPoints.find(e => e.id === 'browser') !== undefined
    }
  }
}
</script>
